<template>
  <div class="chat-input">
    <FileInput ref="hiddenDropzone" v-on:fileAdded="fileAdded" v-on:newFile="isUploading = true"/>
    <b-field expanded>
      <b-input expanded v-model="messageContent"></b-input>
      <p class="control">
        <b-button :loading="isUploading" @click="triggerUpload" class="button is-info">
          <b-icon pack="fas" icon="paperclip"></b-icon>
        </b-button>
      </p>
      <p class="control">
        <b-button  @click="emitNewMessage" class="button is-primary">
          <b-icon pack="fas" icon="chevron-right"></b-icon>
        </b-button>
      </p>
    </b-field>
  </div>
</template>

<script>
import S3UploadInputHidden from '@/components/common/S3UploadInputHidden.vue'
export default {
  components: {
    FileInput: S3UploadInputHidden
  },
  mixins: [],
  data() {
    return {
      messageContent: null,
      file: {},
      isUploading: false
    }
  },
  computed: {},
  mounted() {},
  methods: {
    triggerUpload() {
      this.$refs.hiddenDropzone.$refs.myVueDropzone.$el.click()
    },
    fileAdded(f) {
      let fileName = prompt(this.$t('Nombre del archivo'));
      this.messageContent = fileName + ": " + f.s3ObjectLocation
      this.isUploading = false
    },
    emitNewMessage: function() {
      this.$emit('newMessage', { text: this.messageContent })
      this.messageContent = null
    }
  }
}
</script>

<style lang="scss" scoped>
.field .button.is-primary {
  height: 100%;
  width: 50px;
}

#fileInput .bulma-upload-button {
  color: white !important;
}
</style>
